import React from 'react'
import { useBreakpoint } from '@vtex/admin-ui'

import type { ProductDetailsDrawer_Product$key } from './__generated__/ProductDetailsDrawer_Product.graphql'
import { ProductDetailsSectionContent } from './ProductDetailsSectionContent'

type ProductDetailsSectionDesktopProps = {
  productDescription: ProductDetailsDrawer_Product$key
}

export const ProductDetailsSectionDesktop = ({
  productDescription,
}: ProductDetailsSectionDesktopProps) => {
  const { breakpoint } = useBreakpoint()
  const isMobileOrTablet = ['mobile', 'tablet'].includes(breakpoint)

  if (isMobileOrTablet) {
    return null
  }

  return (
    <ProductDetailsSectionContent productDescription={productDescription} />
  )
}
